// extracted by mini-css-extract-plugin
module.exports = {"container":"NoTariffWarning_container__3iw0w","warningIcon":"NoTariffWarning_warningIcon__zj2sa","content":"NoTariffWarning_content__BZYFd","link":"NoTariffWarning_link__3H5NG"};